import { request, METHOD } from '@/utils/request.js'





// 月份
export const getSchoolMonthByTerm = (form) => {
  return request(
    '/h5Mfitness/parent/getSchoolMonthByTermSmallSchool',
    METHOD.POST,
    {
      ...form
    })
}
// 学期
export const getTermList = (form) => {
  return request(
    '/h5Mfitness/parent/getTermListSmallSchool',
    METHOD.POST,
    {
      ...form
    })
}


//列表
export function getSunrunArch(data) {
  return request(
    '/h5Mfitness/parent/getSunrunArchSmallSchool',
    METHOD.POST,
    data
  )
}

//详情
export function getSunrunArchDetail(data) {
  return request(
    '/wxapi/platform/active/getSunrunArchDetail',
    METHOD.POST,
    data
  )
}
// 晨跑
export function getSunrunArchPjxy(data) {
  return request(
    '/wxapi/platform/active/getSunrunArchPjxy',
    METHOD.POST,
    data
  )
}
